import React from 'react'
import Headerbgimg from '../element/Headerbgimg';
import HomeServices from '../element/HomeServices';
import About from '../element/About';
import Galerie from '../element/Galerie.jsx';
import { Helmet } from 'react-helmet';

const Home = () => {
  return (
    <>
      <Helmet>
        <title>QUAISDANROC</title>
        <meta name="description" content="Réalisons ensemble le quai de vos rêves !" />
        <meta name="keywords" content="QUAIS , ACCES AU LAC" />
        <meta property="og:title" content="QUAISDANROC" />
        <meta property="og:description" content="Réalisons ensemble le quai de vos rêves !" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://quaisdanroc.ca" />
        <meta property="og:image" content="https://quaisdanroc.ca/images/quais-surpoteaux.jpg" />
        {/* <link rel="canonical" href="https://monsite.com" /> */}
      </Helmet>

      <Headerbgimg />
      <HomeServices />
      <About />
      <Galerie />
    </>
  )
}

export default Home